import { ActionLookupReducer, lookupTableReducer } from 'Modules/core/redux';

import { newsActions } from './actions';
import { IError, IStatus, Reducer } from './types';


const defaultState: Reducer = {
    busy: false,
    errors: { },
};

const actionLookup: ActionLookupReducer<Reducer> = {
    [`${newsActions.setStatus}`]: (state, status: IStatus) => ({
        ...state,
        ...status,
    }),
    [`${newsActions.setError}`]: (state, error: IError) => ({
        ...state,
        errors: {
            ...state.errors,
            [error.type]: error.key,
        },
    }),
};

export const reducer = lookupTableReducer(defaultState, actionLookup);
